import { now } from "@@/shared/date-time/date-time";
import type { EntityState} from "@@/shared/entity-status";
import { entityStateZodSchema } from "@@/shared/entity-status";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    IsoAndUnixTimestamp} from "../../date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "../../date-time/iso-and-unix";
import type { ProviderId} from "../../providers/provider-id";
import { providerIdZodSchema } from "../../providers/provider-id";
import type { UserId} from "../../users/user-id";
import { userIdZodSchema } from "../../users/user-id";
import type { ApiKeyId} from "./api-key-id";
import { apiKeyIdZodSchema } from "./api-key-id";

type ApiKey = {
    readonly _id: ApiKeyId;
    readonly _type: "API_KEY";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _status: EntityState;
    readonly ownerId: ProviderId | UserId;
    readonly validUntil: IsoAndUnixTimestamp | null;
    readonly scopes: string[];
    readonly key: ApiKeyId;
};

// TODO: ApiKey is a little weird
// TODO: Seems to have both an id and a key prop.
// TODO: Both were generated the same way
// TODO: Resulting in a key_xxxxxxxxxx
// TODO: We probably should only have on value like that
// TODO: also, maybe rename db collection api-keys (plural)
// TODO: to conform to the pattern.
// TODO: #future-cleanup

const apiKeyZodSchema: z.ZodSchema<ApiKey> = z.object({
    _id: apiKeyIdZodSchema,
    _type: z.literal("API_KEY"),
    _createdAt: isoAndUnixZodSchema,
    _status: entityStateZodSchema,
    ownerId: z.union([providerIdZodSchema, userIdZodSchema]),
    validUntil: isoAndUnixZodSchema.nullable(),
    scopes: z.array(z.string()),
    key: apiKeyIdZodSchema,
});

const apiKeyFactory = (
    params: Except<ApiKey, "_id" | "_type" | "_status" | "_createdAt">,
): ApiKey => {
    return {
        ...params,
        _id: generateId({ prefix: "api_key__" }),
        _type: "API_KEY",
        _status: "ACTIVE",
        _createdAt: now(),
    };
};

export { apiKeyFactory, apiKeyZodSchema };
export type { ApiKey };
